import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../stores';
import { Layers, Modals } from '../stores/layers';
import { Modal } from '../components/Modal';
import { useTranslateFunction } from '../helpers/useTranslationHook';
import { Input } from '../components/Input';
import { Select } from '../components/Select';
import { Textarea } from '../components/Textarea';

export const AddMyLocationsModal = observer(() => {
  const { t } = useTranslateFunction(Layers.myLocations);
  const store = useStore();

  const { layers, myLocations } = store;
  const { setError, errors } = store.myLocations;

  // Checks if keys are inexistant / missing a translation
  let hasDefaultTitle = !['modal-name-input-default', ''].includes(
    t('modal-name-input-default'),
  );
  let hasDefaultDescription = !['modal-description-input-default', ''].includes(
    t('modal-description-input-default'),
  );

  const [title, setTitle] = useState(
    hasDefaultTitle ? t('modal-name-input-default') : '',
  );
  const [description, setDescription] = useState(
    hasDefaultDescription ? t('modal-description-input-default') : '',
  );

  const onSubmit = () => {
    const categorySelect = document.getElementById('categories');
    const category = categorySelect.options[categorySelect.selectedIndex].value;
    const categoryValue =
      categorySelect.options[categorySelect.selectedIndex].value;

    const colorSelect = document.getElementById('color');
    const color = colorSelect.options[colorSelect.selectedIndex].text;
    const colorValue = colorSelect.options[colorSelect.selectedIndex].value;

    const categories = ['parking', 'food', 'shopping', 'sight'];
    const colors = ['blue', 'green', 'red', 'yellow'];

    setError('title', !title.length);
    setError('description', !description.length);
    setError('alreadyExists', false);
    setError('color', !colors.includes(colorValue));
    setError('category', !categories.includes(categoryValue));

    const success = myLocations.add(
      title,
      description,
      colorValue,
      category,
      myLocations,
    );

    if (success) {
      setTitle(hasDefaultTitle ? t('modal-name-input-default') : '');
      setDescription(
        hasDefaultDescription ? t('modal-description-input-default') : '',
      );
    }
  };

  const handleTitleChange = (event) => {
    event.persist();
    setTitle(event.target.value);
    if (errors.title) setError('title', false);
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
    if (errors.description) setError('description', false);
  };

  return (
    <Modal
      icon="icon-region"
      headline={t('add-to-my-location')}
      content={t('add-my-location-explanation')}
      isOpen={layers.activeModal === Modals.addMyLocations}
      acceptAction={() => {
        onSubmit();
      }}
      acceptText={t('button-ok')}
      abortAction={() => {
        layers.closeModal();
        myLocations.deactivate();
      }}
      abortText={t('button-abort')}
      className="no-scrollbar"
    >
      <Input
        id="poi-name"
        className="mb-5"
        label={t('modal-name-input')}
        placeholder={t('modal-name-input-placeholder')}
        value={title}
        onChange={handleTitleChange}
        autoFocus={true}
        rounded="rounded-md"
        required
      />

      {errors.alreadyExists ? (
        <div className="form-error">{t('error-handling-exists')}</div>
      ) : null}

      {errors.title ? (
        <div className="form-error">{t('error-handling-empty-title')}</div>
      ) : null}

      <Select
        id="categories"
        label={t('modal-category-input')}
        rounded="rounded-md"
        className="mb-5"
        attribute="categories"
        required
        options={[
          { value: 'parking', label: t('modal-category-parking') },
          { value: 'food', label: t('modal-category-food') },
          { value: 'shopping', label: t('modal-category-shopping') },
          { value: 'sight', label: t('modal-category-sight') },
        ]}
      />

      {errors.category ? (
        <div className="form-error">{t('error-handling-empty-category')}</div>
      ) : null}

      <Select
        id="color"
        label={t('modal-color-input')}
        rounded="rounded-md"
        className="mb-5"
        attribute="color"
        required
        options={[
          { value: 'blue', label: t('modal-color-blue') },
          { value: 'green', label: t('modal-color-green') },
          { value: 'red', label: t('modal-color-red') },
          { value: 'yellow', label: t('modal-color-yellow') },
        ]}
      />

      {errors.color ? (
        <div className="form-error">{t('error-handling-empty-color')}</div>
      ) : null}

      <Textarea
        label={t('modal-description-input')}
        rounded="rounded-md"
        className="mb-5"
        id="poi-description"
        value={description}
        placeholder={t('modal-description-input-placeholder')}
        onChange={handleDescriptionChange}
      />

      {errors.description ? (
        <div className="form-error">Empty description</div>
      ) : null}
    </Modal>
  );
});
